import { Component, Inject, Input } from '@angular/core';
import { ReportsColumnsDialogComponent } from '../reports/reports.columns.dialog.component';
import { DatePipe } from '@angular/common';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { UITKTableDataSource } from '@uhg-harmony/uitk-angular';
import { style } from '@angular/animations';
import { ClaimSearchService } from '../services/claimSearch.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Component({
    selector: 'app-claim-card',
    templateUrl: './claim-card.component.html',
    styleUrls: ['./claim-card.component.css'],
    standalone: false
})
export class ClaimCardComponent extends ReportsColumnsDialogComponent {
  @Input() claimDetail: any;
  @Input() showProcessStates: boolean = true;
  @Input() cardTitle: string = 'Claim Details';
  @Input() isSelected: boolean = false;
  @Input() isAuditExpanded: boolean = false;
  @Input() claimAuditMapping: [] = [];
  dataSource = new UITKTableDataSource<any>([]);
  auditCount: number;
  claimAudit = new UITKTableDataSource<any>([]);
  myMap: Map<string, string> = new Map();
  medClaimSks: string[] = [];
  @Input() prtySk: string ; 
  confirmPopupConfig: any = {
    isLoading: false,
  };

entityCodeMap: Map<string, string> = new Map<string, string>([
    ['IL', 'Member'],
    ['PR', 'Payer'],
    ['85', 'Billing Provider'],
    ['82', 'Rendering Provider'],
    ['DQ', 'Supervising Provider'],
    ['71', 'Attending Provider'],
    ['DN', 'Referring Provider'],
    ['P3', 'Primary Care Provider'],
    ['77', 'Service/Service Facility Provider'],
    ['QB', 'Purchase Service Provider'],
    ['DK', 'Ordering Physician'],
    ['72', 'Operating Physician'],
    ['ZZ', 'Other Operating Physician']
  ]);

  constructor(@Inject(SESSION_STORAGE) public sessionStorage: WebStorageService,
    public dateFormat: DatePipe, private claimService: ClaimSearchService) {
    super(sessionStorage, dateFormat);
  }

  columns: any[] = [
    { label: 'Edited by', id: 'editedBy', dataType: 'text', showAlways: true, hideColumn: false, style: { width: '20%' } },
    { label: 'Edit date and time', id: 'recievedDateTime', dataType: 'text', enableFiltering: false, showAlways: true, hideColumn: false, style: { width: '60%' } },
    { label: 'Status', id: 'prcsStateNm', dataType: 'text', enableFiltering: false, showAlways: true, hideColumn: false, style: { width: '20%' } }
  ];

  auditColumns: any[] = [
    { label: 'Edited by', id: 'editedBy', dataType: 'text', showAlways: true, hideColumn: false, minWidth: '15%' },
    { label: 'Edit date and time', id: 'editDateTime', dataType: 'text', enableFiltering: false, showAlways: true, hideColumn: false, minWidth: '15%' },
    { label: '', id: 'oldData', dataType: 'text', enableFiltering: false, showAlways: true, hideColumn: false, minWidth: '35%' },
    { label: '', id: 'newData', dataType: 'text', enableFiltering: false, showAlways: true, hideColumn: false, minWidth: '35%' }
  ];

  auditUpdateValueCount: number;
  

  getCellValue(record: any, columnId: string) {
    return record[columnId];
  }
  
  ngOnInit() {
    this.dataSource.data = this.claimDetail?.medClmPrcsStateLst ?
      JSON.parse(JSON.stringify(this.claimDetail.medClmPrcsStateLst)) : [];
    // Collect medClaimSk into an array
    this.medClaimSks = this.collectAllMedClaimSk();

    // Call audit API for all medClaimSks
    if (this.medClaimSks.length > 0) {
      this.getClaimAuditDetails(this.medClaimSks);
    }

    // this.claimAudit = this.claimDetail?.claimAuditList ?
    // JSON.parse(JSON.stringify(this.claimDetail.claimAuditList)) : [];


    this.setValueInMap();
  }

  collectAllMedClaimSk(): string[] {
    const result: string[] = [];

    // Add main medClaimSk from claimDetail
    if (this.claimDetail?.medClaimSk) {
      result.push(this.claimDetail.medClaimSk);
    }

    // Add from medClmPrcsStateLst if exists
    if (Array.isArray(this.claimDetail?.medClmPrcsStateLst)) {
      this.claimDetail.medClmPrcsStateLst.forEach((item: any) => {
        if (item?.medClaimSk && !result.includes(item.medClaimSk)) {
          result.push(item.medClaimSk);
        }
      });
    }

    return result;
  }

getClaimAuditDetails(medClaimSks: string[]): void {
  if (!medClaimSks || medClaimSks.length === 0) {
    this.claimAudit.data = [];
    return;
  }

  this.confirmPopupConfig.isLoading = true;

  // Create an array of observables for each medClaimSk
  const auditRequests = medClaimSks.map(medClaimSk => 
    this.claimService.getClaimAuditDetail(medClaimSk, this.prtySk).pipe(
      catchError(error => {
        console.error(`Error loading audit for medClaimSk ${medClaimSk}:`, error);
        return of({ data: [] }); // Return empty data on error
      })
    )
  );

  // Execute all requests in parallel using forkJoin
  forkJoin(auditRequests).subscribe({
    next: (responses: any[]) => {
      this.confirmPopupConfig.isLoading = false;
      
      // Combine all audit data from all responses
      const allAuditData: any[] = [];
      responses.forEach((response: any) => {
        if (response?.data && Array.isArray(response.data)) {
          allAuditData.push(...response.data);
        } else if (Array.isArray(response)) {
          allAuditData.push(...response);
        }
      });

      // Sort by editDateTime (most recent first)
      allAuditData.sort((a, b) => {
        const dateA = new Date(a.editDateTime || 0).getTime();
        const dateB = new Date(b.editDateTime || 0).getTime();
        return dateB - dateA;
      });

      // Set the combined audit data
      this.claimAudit.data = allAuditData;
      
      // Also store in claimDetail for reference
      this.claimDetail.claimAuditList = allAuditData;
    },
    error: (error) => {
      this.confirmPopupConfig.isLoading = false;
      console.error('Error loading claim audit details:', error);
      this.claimAudit.data = [];
    }
  });
}

  setValueInMap() {
    if (Array.isArray(this.claimAuditMapping) && this.claimAuditMapping.length) {
      this.claimAuditMapping.forEach((m: any) => {
        if (!m || !m.auditKey) return;
        // respect active flag if present
        if (m.active === false) return;

        // convert full auditKey -> last two segments without indices
        const mapKey = m.auditKey;
        const mapVal = (m.auditValue ?? '').toString();

        if (mapKey) {
          this.myMap.set(mapKey, mapVal);
        }
      });
    }

  }

  getStatusDisplay(text: string): string {
    if (!text && text !== '') return '';
    const lowerText = text?.toString().toLowerCase() ?? '';

    if (lowerText.includes('original')) {
      return 'ORIGINAL';
    } else if (lowerText.includes('delete') || lowerText.includes('void')) {
      return 'VOID';
    } else if (lowerText.includes('correction') || lowerText.includes('adjustment')) {
      return 'CORRECTION';
    }

    return text;
  }

  getDisplayValue(columnId: string, value: any): string {
    if (columnId === 'editedBy') {
      if (value && (value.toString().toUpperCase().includes('CMS') || value.toString().toUpperCase().includes('INC'))) {
        return value;
      }
      return 'Optum Process';
    }

    return value !== null && value !== undefined && value !== 'null' ? value : '';
  }

  getAuditDisplayValue(columnId: string, rowData: any): string {
    if (columnId === 'editedBy') {
      return rowData.editedBy;
    }
    if (columnId === 'editDateTime') {
      return rowData.editDateTime;
    }
    if (columnId === 'oldData') {
      const oldValue = (rowData?.jsonData?.oldData !== null && rowData?.jsonData?.oldData !== 
        undefined && rowData?.jsonData?.oldData !== 'null' && rowData?.jsonData?.oldData !== '') ? rowData.jsonData.oldData : 'NA';
      return oldValue;
    }
    if (columnId === 'newData') {
      const newValue = (rowData?.jsonData?.newData !== null && rowData?.jsonData?.newData !== 
        undefined && rowData?.jsonData?.newData !== 'null' && rowData?.jsonData?.newData !== '') ? rowData.jsonData.newData : 'NA';
      return newValue;
    }

  }

  // getAuditDisplayKey(rowData: any): string {

  //   const left = this.getValue(rowData?.jsonData?.path,rowData?.jsonData?.tableName) ?? '';
  //   return left;

  // }

    getAuditDisplayKey(rowData: any): string {
    const left = this.getValue(rowData?.jsonData?.path, rowData?.jsonData?.tableName) ?? '';
    const entityIdCode = rowData?.jsonData?.entityIdCode || '';
    const entityName = this.entityCodeMap.get(entityIdCode) || '';
    return entityName ? `${entityName}  ${left}` : left;
  }

  onClick() {
    console.log('Button clicked!');
  }


  toggleAudit(): void {

    const has = this.hasAuditData();
    if (!has) {
      this.isAuditExpanded = false;
      return;
    }

    this.isAuditExpanded = !this.isAuditExpanded;
  }

  hasAuditData(): boolean {
    if (!this.claimAudit) return false;

    // normalize to an array of audit entries
    let entries: any[] = [];
    if (Array.isArray(this.claimAudit)) {
      entries = this.claimAudit;
    } else if ((this.claimAudit as any)?.data && Array.isArray((this.claimAudit as any).data)) {
      entries = (this.claimAudit as any).data;
    } else if (typeof this.claimAudit === 'object') {
      // support array-like objects
      entries = Object.values(this.claimAudit).filter(v => v && typeof v === 'object');
    }

    const hasValue = (v: any) => v !== null && v !== undefined && v !== '' && v !== 'null';

    // For the provided JSON each audit entry has jsonData as an object with oldData/newData.
    return entries.some(audit => {
      const jd = audit?.jsonData;
      if (!jd) return false;
      // accept when either oldData or newData contains meaningful data
      return hasValue(jd.oldData) || hasValue(jd.newData);
    });
  }

  getValue(key: string,tableName: string): string | undefined {

    return this.myMap.get(this.getLastTwoSegments(key, tableName));
  }

  getLastTwoSegments(path: string, tableName: string): string {
    if(tableName && tableName.toString().trim() !== ''){
      return tableName+'.'+path;
    }
    if (!path) return '';
    const parts = path.split('.').map(segment => segment.replace(/\[\d+\]/g, ''));
    if (parts && parts.includes('dtpLoop2300DateTimePeriod')) {
       return path.split('.').slice(-2).join('.');
    }
    return parts.slice(-2).join('.');
  }


}